import * as React from 'react';
import {useEffect} from 'react';
import TextField from 'myshubhlife-component/inputTextField';
import {IInputFieldProps} from 'myshubhlife-component/form/FormInterfaceProps';
import axiosInstance from 'utils/axios-request';
import {checkPincodeValidity} from 'firebase/firebaseUtils';

function InputField (props: IInputFieldProps) {
  const PINCODE = 'pincode';
  const IFSC = 'ifsc';
  const PINCODE_LENGTH = 6;

  const handleChange = (fieldName: string, value: string | number, event?: React.FormEvent<HTMLInputElement>) => {
    props.handleFormChange('default', props.index, 'validated');
    props.handleFormChange('', props.index, 'errorMsg');
    props.handleFormChange(value, props.index, 'value');
    if (props.field.type === PINCODE && event.currentTarget.value.length === PINCODE_LENGTH) {
      checkPincodeValidity(event.currentTarget.value, handlePinCodeCheck);
    }
  }
  const handlePinCodeCheck = (result: boolean) => {
    if (result) {
      props.handleFormChange('success', props.index, 'validated');
    } else {
      props.handleFormChange('error', props.index, 'validated');
      props.handleFormChange('Please Enter Valid Pincode', props.index, 'errorMsg');
    }
  }
  const handleBlur = (value) => {
    if (!props.field.value && props.field.value !== 0 && props.field.isRequired !== false && props.field.isReadOnly !== true && props.field.disabled !== true) {
      props.handleFormChange('This field is required', props.index, 'errorMsg');
    } else {
      props.handleFormChange('', props.index, 'errorMsg');
    }
    getValidated(value);
  }
  const getUrlValidation = (baseURL: string, input: number | string) =>
  axiosInstance.request({
      baseURL ,
      url: `${input}`,
      method: "get",
  });
  const getValidated = (value?: string | number) => {
      const newValue = value || value === 0 ? value : props.field.value
      if (newValue) {
        if (props.field.regex && !new RegExp(props.field.regex).test(String(newValue))) {
          props.handleFormChange('error', props.index, 'validated');
          props.handleFormChange(`Please enter a valid ${props.field.label.toLowerCase()}`, props.index, 'errorMsg');
        } else if (props.field.regex) {
          props.handleFormChange('success', props.index, 'validated');
        }
        if (props.field.url) {
          getUrlValidation(props.field.url, newValue).then(response => {
            console.log(response);
          })
        }
        if (props.field.type === PINCODE) {
          if (newValue.toString().length === PINCODE_LENGTH) {
            checkPincodeValidity(newValue.toString(), handlePinCodeCheck);
          } else {
            props.handleFormChange('error', props.index, 'validated');
            props.handleFormChange('Pin Code must be of Length 6', props.index, 'errorMsg');
          }
        }
        if (!props.field.regex && !props.field.url && props.field.type !== PINCODE) {
          props.handleFormChange(newValue, props.index, 'doValidate');
        }
      } else {
        props.handleFormChange('default', props.index, 'validated');
      }
  };
  useEffect(() => {
    getValidated();
  }, []);
  return (
    <div className="s-form-group-field">
      <TextField
          fieldName={props.field.identifier}
          index={props.index}
          type={props.field.type === PINCODE ? 'number': props.field.type ===  IFSC ? 'text': props.field.type}
          placeholder={`Please Enter ${props.field.label.toLowerCase()}`}
          value={props.field.value || ''}
          onChange={handleChange}
          handleBlur={handleBlur}
          label = {props.field.label}
          errorMsg={props.field.errorMsg}
          isRequired={props.field.isRequired}
          tooltipLabel={props.field.tooltipLabel}
          max={props.field.max}
          min={props.field.min}
          validated={props.field.validated}
          regex={props.field.regex}
          url={props.field.url}
          isReadOnly={props.field.isReadOnly}
          disabled={props.field.disabled}
          styleType={props.styleType}
      />
    </div>
  )
}

export default InputField;